/**
 * Component: sa-hfi
 * Description: HFI section controller for video lifecycle
 */
if (!customElements.get('sa-hfi')) {
  class SaHfi extends HTMLElement {
    constructor() {
      super();
      this.handleVisibility = this.handleVisibility.bind(this);
      this.handlePlayClick = this.handlePlayClick.bind(this);
      this.handleEnded = this.handleEnded.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);
    }

    connectedCallback() {
      this.videos = this.querySelectorAll('.sa-hfi__video');
      this.buttons = this.querySelectorAll('.sa-hfi__play-btn');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', this.handlePlayClick);
      });
      if (this.videos) {
        this.videos.forEach((video) => {
          video.addEventListener('ended', this.handleEnded);
          video.addEventListener('play', this.handlePlay);
          video.addEventListener('pause', this.handlePause);
        });
      }

      this.observer = new IntersectionObserver(this.handleVisibility, {
        threshold: 0.25
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.buttons) {
        this.buttons.forEach((btn) => {
          btn.removeEventListener('click', this.handlePlayClick);
        });
      }
      if (this.videos) {
        this.videos.forEach((video) => {
          video.removeEventListener('ended', this.handleEnded);
          video.removeEventListener('play', this.handlePlay);
          video.removeEventListener('pause', this.handlePause);
        });
      }
    }

    handlePlayClick(e) {
      const btn = e.currentTarget;
      const wrapper = btn.closest('.sa-hfi__video-wrapper');
      const video = wrapper ? wrapper.querySelector('.sa-hfi__video') : null;

      if (video) {
        video.play();
        // btn.style.display = 'none'; // Handled by 'play' event
      }
    }

    handlePlay(e) {
      const video = e.currentTarget;
      const wrapper = video.closest('.sa-hfi__video-wrapper');
      const btn = wrapper ? wrapper.querySelector('.sa-hfi__play-btn') : null;
      if (btn) {
        btn.style.display = 'none';
      }
    }

    handlePause(e) {
      const video = e.currentTarget;
      const wrapper = video.closest('.sa-hfi__video-wrapper');
      const btn = wrapper ? wrapper.querySelector('.sa-hfi__play-btn') : null;
      if (btn) {
        btn.style.display = '';
      }
    }

    handleVisibility(entries) {
      const isVisible = entries.some((e) => e.isIntersecting);
      
      if (isVisible) {
        this.classList.add('is-visible');
      }

      if (!this.videos) return;
      
      this.videos.forEach((video) => {
        if (isVisible) {
          try {
            video.play().catch(e => {
              // Auto-play prevented
            });
          } catch (_e) {}
        } else {
          try {
            video.pause();
          } catch (_e) {}
        }
      });
    }

    handleEnded(e) {
      const video = e.currentTarget;
      const wrapper = video.closest('.sa-hfi__video-wrapper');
      const btn = wrapper ? wrapper.querySelector('.sa-hfi__play-btn') : null;
      if (btn) {
        btn.style.display = '';
      }
    }
  }

  customElements.define('sa-hfi', SaHfi);
}